export default __webpack_public_path__ + "static/media/Vector3.b27960f3.svg";